import {
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import React from 'react';
import {SupportCustomerPlanModel} from '../../../../model/support/support-customer-plan.model';
import {useSupportPlanUpdateDrawerState} from '../state/support-plan-update-drawer-state';

type Props = {
  isDrawerOpen: boolean
  onDrawerClosed: () => void
  supportPlan: SupportCustomerPlanModel
  refreshSupportPlan: () => Promise<void>
}

export const SupportPlanUpdateDrawer = ({supportPlan, refreshSupportPlan, isDrawerOpen, onDrawerClosed}: Props) => {
  const state = useSupportPlanUpdateDrawerState({supportPlan, refreshSupportPlan})

  const buildSupportPlanType = () => <FormControl fullWidth>
    <InputLabel id="demo-simple-select-label">{state.translateLocal('planType')}</InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={state.planType}
      label={state.translateLocal('planType')}
      onChange={event => state.setPlanType(event.target.value)}
    >
      <MenuItem value={'BASIC'}>{state.translate('support.plan.type.BASIC')}</MenuItem>
      <MenuItem value={'ADVANCED'}>{state.translate('support.plan.type.ADVANCED')}</MenuItem>
      <MenuItem value={'INDIVIDUAL'}>{state.translate('support.plan.type.INDIVIDUAL')}</MenuItem>
    </Select>
  </FormControl>

  const buildMonthlyHours = () =>  <TextField
    label={state.translateLocal('monthlyHours')}
    disabled={state.monthlyHoursDisabled}
    type="number"
    value={state.monthlyHours}
    onChange={(e) => {
      const value = Number(e.target.value)
      if (value >= 0 && Number.isInteger(value)) {
        state.setMonthlyHours(value)
      }
    }}
    fullWidth
    inputProps={{
      min: 0,
      step: 1,
    }}
    InputLabelProps={{
      shrink: true,
    }}
  />

  const buildMonthlyCost = () =>  <TextField
    label={`${state.translateLocal('monthlyCost')} [€]`}
    disabled={state.monthlyCostDisabled}
    type="number"
    value={state.monthlyCost}
    onChange={(e) => {
      const value = Number(e.target.value)
      if (value >= 0) {
        state.setMonthlyCost(value)
      }
    }}
    fullWidth
    inputProps={{
      min: 0,
    }}
    InputLabelProps={{
      shrink: true,
    }}
  />

  return <Drawer
    anchor="right"
    open={isDrawerOpen}
    onClose={onDrawerClosed}
    PaperProps={{
      sx: {
        width: 480,
        marginTop: '64px',
        height: `calc(100% - 64px)`,
        position: 'fixed',
        right: 0,
        padding: 3,
        overflowY: 'auto',
      }
    }}
  >
    <h2>{state.translateLocal('title')}</h2>
    <form onSubmit={async (event) => {
      event.preventDefault();
      await state.handleSubmit()
      onDrawerClosed()
    }}>
      <Stack spacing={3}>
        {buildSupportPlanType()}
        {buildMonthlyHours()}
        {buildMonthlyCost()}
        <Button type="submit" variant="contained" color="primary">
          {state.translate('common.save.title')}
        </Button>
        <Button variant="outlined" onClick={onDrawerClosed}>
          {state.translate('common.cancel.title')}
        </Button>
      </Stack>
    </form>
  </Drawer>
}